import { useState } from 'react'
import smoothscroll from 'smoothscroll-polyfill'
import classNames from 'classnames'

export const SpySidebar = ({ settings }) => {
  const [selectedSection, setSelectedSection] = useState(
    settings[0].ref
  )
  const sectionClasses = (ref) =>
    classNames('item-spy-sidebar__element', {
      '-active': ref === selectedSection,
    })

  const scrollToSection = (ref, text) => () => {
    const section = document.getElementById(text)

    if (section) {
      ref.current.scrollIntoView({
        block: 'center',
        behavior: 'smooth',
      })

      smoothscroll.polyfill()
      setSelectedSection(ref)
    }
  }

  return (
    <div className="item-spy-sidebar">
      <p className="item-spy-sidebar__title">Sections</p>
      <ul className="item-spy-sidebar__list">
        {settings.map(({ text, ref }) => (
          <li
            key={text}
            className={sectionClasses(ref)}
            onClick={scrollToSection(ref, text)}
          >
            {text}
          </li>
        ))}
      </ul>
    </div>
  )
}
